var _g, _g2, _g3, _g4, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo06(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_58",
    "data-name": "Group 58",
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.542,
    height: 73.503,
    viewBox: "0 0 72.542 73.503",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(1.633 20.941)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M-1499.659,2394.181a2.311,2.311,0,0,1-.474.149c-.221.065-.333.1-.337.1v-.669a4.459,4.459,0,0,0,.568-.25,1.465,1.465,0,0,0,.451-.327h.7v5.259h-.9Z",
    transform: "translate(1500.47 -2393.128)",
    fill: "#6b6a7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M-1495.461,2398.167a1.443,1.443,0,0,1-.328-1v-.078h.864a1.13,1.13,0,0,0,.094.539.388.388,0,0,0,.367.163.361.361,0,0,0,.354-.244,2.451,2.451,0,0,0,.1-.841v-.623a.594.594,0,0,1-.279.239,1.093,1.093,0,0,1-.448.085q-1.105,0-1.105-1.546a2.206,2.206,0,0,1,.329-1.29,1.184,1.184,0,0,1,1.041-.465,1.208,1.208,0,0,1,1.039.458,2.041,2.041,0,0,1,.338,1.238v1.864a2.507,2.507,0,0,1-.308,1.345,1.166,1.166,0,0,1-1.069.487A1.3,1.3,0,0,1-1495.461,2398.167Zm1.451-2.725v-.818a1.491,1.491,0,0,0-.1-.6.367.367,0,0,0-.362-.221.362.362,0,0,0-.36.238,1.845,1.845,0,0,0-.1.691,5.339,5.339,0,0,0,.022.556.6.6,0,0,0,.124.321.39.39,0,0,0,.321.124A.5.5,0,0,0-1494.01,2395.443Z",
    transform: "translate(1499.439 -2393.111)",
    fill: "#6b6a7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M-1490.355,2398.126a2.016,2.016,0,0,1-.288-1.184h.876a1.8,1.8,0,0,0,.1.675.376.376,0,0,0,.382.226.367.367,0,0,0,.319-.14.774.774,0,0,0,.134-.376,5.766,5.766,0,0,0,.029-.659,2.23,2.23,0,0,0-.1-.766.39.39,0,0,0-.4-.247.421.421,0,0,0-.308.124.72.72,0,0,0-.186.337h-.773l.052-2.928h2.364v.8h-1.61l-.052,1.267a.761.761,0,0,1,.318-.2,1.319,1.319,0,0,1,.455-.075.911.911,0,0,1,.827.425,2.232,2.232,0,0,1,.271,1.2,3.891,3.891,0,0,1-.114,1.019,1.222,1.222,0,0,1-.412.656,1.318,1.318,0,0,1-.845.241A1.194,1.194,0,0,1-1490.355,2398.126Z",
    transform: "translate(1498.281 -2393.128)",
    fill: "#6b6a7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M-1484.209,2393.875h-1.422v-.687h2.305v.545l-1.065,4.715h-.87Z",
    transform: "translate(1497.164 -2393.128)",
    fill: "#6b6a7e"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(57.587 20.941)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M-1428.475,2397.794l1.3-2.007.123-.188a5.166,5.166,0,0,0,.328-.588,1.289,1.289,0,0,0,.107-.536c0-.406-.143-.611-.429-.611a.427.427,0,0,0-.416.227,1.348,1.348,0,0,0-.117.611v.221h-.876v-.233a1.825,1.825,0,0,1,.331-1.161,1.261,1.261,0,0,1,1.052-.419,1.325,1.325,0,0,1,1,.358,1.406,1.406,0,0,1,.34,1.013,1.83,1.83,0,0,1-.084.565,2.37,2.37,0,0,1-.2.461q-.117.2-.363.572l-1.079,1.629h1.6v.721h-2.617Z",
    transform: "translate(1428.475 -2393.111)",
    fill: "#6b6a7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M-1423.087,2398.094a1.672,1.672,0,0,1-.35-1.111v-2.332a1.7,1.7,0,0,1,.341-1.129,1.27,1.27,0,0,1,1.034-.41,1.251,1.251,0,0,1,1.024.413,1.711,1.711,0,0,1,.341,1.126v2.332a1.668,1.668,0,0,1-.35,1.111,1.256,1.256,0,0,1-1.014.415A1.272,1.272,0,0,1-1423.087,2398.094Zm1.481-1.124v-2.306a1.471,1.471,0,0,0-.091-.561.355.355,0,0,0-.365-.219.358.358,0,0,0-.368.216,1.45,1.45,0,0,0-.091.564v2.306q0,.765.459.765T-1421.606,2396.97Z",
    transform: "translate(1427.353 -2393.111)",
    fill: "#6b6a7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M-1417.136,2394.181a2.318,2.318,0,0,1-.473.149c-.221.065-.334.1-.338.1v-.669a4.466,4.466,0,0,0,.569-.25,1.475,1.475,0,0,0,.451-.327h.695v5.259h-.9Z",
    transform: "translate(1426.129 -2393.128)",
    fill: "#6b6a7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M-1411.863,2393.875h-1.422v-.687h2.305v.545l-1.064,4.715h-.87Z",
    transform: "translate(1425.091 -2393.128)",
    fill: "#6b6a7e"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(0 54.626)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M-1502.571,2436.453h2.894a4.175,4.175,0,0,1,2.539.665,2.656,2.656,0,0,1,.891,2.272q0,2.214-1.693,2.475,2.024.391,2.025,2.9a3.513,3.513,0,0,1-.811,2.545,3.234,3.234,0,0,1-2.459.868h-3.387Zm2.866,4.789a1.58,1.58,0,0,0,1.266-.412,2.109,2.109,0,0,0,.339-1.338,1.435,1.435,0,0,0-.441-1.223,2.536,2.536,0,0,0-1.47-.326h-.433v3.3Zm.086,5.427a1.6,1.6,0,0,0,1.3-.448,2.37,2.37,0,0,0,.361-1.477,2.419,2.419,0,0,0-.4-1.541,1.643,1.643,0,0,0-1.339-.485h-.752v3.95Z",
    transform: "translate(1502.571 -2436.453)",
    fill: "#6b6a7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M-1483.19,2436.453h2.286l2.345,11.72h-1.983l-.463-2.705h-2.04l-.477,2.705h-2.012Zm1.954,7.656-.8-4.921-.8,4.921Z",
    transform: "translate(1498.775 -2436.453)",
    fill: "#6b6a7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M-1467.6,2436.453h2.126v5.152l2.33-5.152h2.04l-2.243,5.224,2.475,6.5H-1463l-1.954-5.323-.521.882v4.442h-2.126Z",
    transform: "translate(1494.78 -2436.453)",
    fill: "#6b6a7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M-1450.251,2436.453h4.92v1.5h-2.793v3.372h2.2v1.491h-2.2v3.892h2.821v1.461h-4.948Z",
    transform: "translate(1490.914 -2436.453)",
    fill: "#6b6a7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M-1434.835,2436.453h2.822a4.509,4.509,0,0,1,2.764.7,2.864,2.864,0,0,1,.912,2.41,4.352,4.352,0,0,1-.325,1.815,1.993,1.993,0,0,1-1.122,1.021l1.634,5.773h-2.142l-1.4-5.367h-1.013v5.367h-2.127Zm2.807,5.022a1.689,1.689,0,0,0,1.3-.42,2.008,2.008,0,0,0,.383-1.375,2.138,2.138,0,0,0-.34-1.345,1.5,1.5,0,0,0-1.223-.419h-.8v3.56Z",
    transform: "translate(1487.479 -2436.453)",
    fill: "#6b6a7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M-1415.556,2443.7l-2.372-7.25h2l1.448,4.645,1.359-4.645h1.955l-2.346,7.25v4.47h-2.04Z",
    transform: "translate(1483.713 -2436.453)",
    fill: "#6b6a7e"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    transform: "translate(18.452 70.313)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M-1478.829,2456.682h1.28v.391h-.715v.908h.584v.4h-.584v1.419h-.565Z",
    transform: "translate(1478.829 -2456.647)",
    fill: "#6b6a7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M-1474.808,2456.682h.749a1.2,1.2,0,0,1,.734.186.76.76,0,0,1,.242.64,1.168,1.168,0,0,1-.086.483.525.525,0,0,1-.3.271l.434,1.535h-.567l-.374-1.427h-.27v1.427h-.564Zm.746,1.333a.443.443,0,0,0,.343-.111.531.531,0,0,0,.1-.365.569.569,0,0,0-.09-.357.4.4,0,0,0-.325-.112h-.212v.946Z",
    transform: "translate(1477.933 -2456.647)",
    fill: "#6b6a7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M-1470.055,2456.682h1.306v.4h-.741v.9h.584v.4h-.584v1.034h.75v.389h-1.314Z",
    transform: "translate(1476.874 -2456.647)",
    fill: "#6b6a7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M-1465.831,2459.589a1.115,1.115,0,0,1-.228-.711l.488-.1a1.074,1.074,0,0,0,.094.451.275.275,0,0,0,.26.156.236.236,0,0,0,.193-.079.326.326,0,0,0,.064-.214.557.557,0,0,0-.082-.311,1.562,1.562,0,0,0-.26-.284l-.392-.342a1.17,1.17,0,0,1-.271-.333.886.886,0,0,1-.091-.421.741.741,0,0,1,.215-.568.847.847,0,0,1,.6-.2.67.67,0,0,1,.572.229,1.143,1.143,0,0,1,.2.617l-.489.085a1.163,1.163,0,0,0-.067-.381.215.215,0,0,0-.217-.131.271.271,0,0,0-.207.08.3.3,0,0,0-.075.211.462.462,0,0,0,.062.25,1.007,1.007,0,0,0,.192.219l.389.343a1.726,1.726,0,0,1,.341.407.976.976,0,0,1,.123.5.789.789,0,0,1-.1.4.7.7,0,0,1-.275.271.826.826,0,0,1-.407.1A.8.8,0,0,1-1465.831,2459.589Z",
    transform: "translate(1475.984 -2456.637)",
    fill: "#6b6a7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M-1461.53,2456.682h.565v1.3h.634v-1.3h.57v3.114h-.57v-1.407h-.634v1.407h-.565Z",
    transform: "translate(1474.975 -2456.647)",
    fill: "#6b6a7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M-1453.483,2456.682h.769a1.113,1.113,0,0,1,.675.176.7.7,0,0,1,.236.6c0,.392-.149.611-.45.657.36.068.539.325.539.769a.935.935,0,0,1-.215.677.863.863,0,0,1-.654.231h-.9Zm.762,1.272a.416.416,0,0,0,.336-.109.56.56,0,0,0,.09-.357.379.379,0,0,0-.117-.324.676.676,0,0,0-.391-.087h-.115v.877Zm.023,1.441a.425.425,0,0,0,.345-.118.629.629,0,0,0,.1-.393.642.642,0,0,0-.106-.409.433.433,0,0,0-.354-.129h-.2v1.049Z",
    transform: "translate(1473.182 -2456.647)",
    fill: "#6b6a7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M-1448.75,2456.682h.749a1.2,1.2,0,0,1,.735.186.76.76,0,0,1,.241.64,1.157,1.157,0,0,1-.085.483.528.528,0,0,1-.3.271l.434,1.535h-.57l-.371-1.427h-.269v1.427h-.566Zm.746,1.333a.446.446,0,0,0,.344-.111.531.531,0,0,0,.1-.365.559.559,0,0,0-.091-.357.4.4,0,0,0-.325-.112h-.211v.946Z",
    transform: "translate(1472.127 -2456.647)",
    fill: "#6b6a7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M-1444,2456.682h1.307v.4h-.742v.9h.584v.4h-.584v1.034h.75v.389H-1444Z",
    transform: "translate(1471.068 -2456.647)",
    fill: "#6b6a7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M-1439.481,2456.682h.607l.623,3.114h-.526l-.124-.72h-.542l-.127.72h-.534Zm.519,2.032-.211-1.307-.212,1.307Z",
    transform: "translate(1470.201 -2456.647)",
    fill: "#6b6a7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M-1435.342,2456.682h.734a1.423,1.423,0,0,1,.592.1.6.6,0,0,1,.3.312,1.42,1.42,0,0,1,.091.556v1.134a1.514,1.514,0,0,1-.091.572.645.645,0,0,1-.3.33,1.264,1.264,0,0,1-.574.109h-.757Zm.742,2.717a.45.45,0,0,0,.272-.065.293.293,0,0,0,.109-.183,1.937,1.937,0,0,0,.022-.348v-1.191a1.343,1.343,0,0,0-.027-.315.239.239,0,0,0-.113-.159.54.54,0,0,0-.271-.053h-.169v2.315Z",
    transform: "translate(1469.14 -2456.647)",
    fill: "#6b6a7e"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M-1470.424,2412.4a.494.494,0,0,1-.076-.005A.5.5,0,0,0-1470.424,2412.4Zm18.555,1.021h0Zm-.605-23.771.11,1.365-.482-5.971.333.333-.284.283.108,1.333,12.963-12.964a1.466,1.466,0,0,0,0-2.071l-5.358-5.356a1.464,1.464,0,0,0-2.072,0l-11.608,11.608,3.759,3.235-2.776-2.776,3.406-3.407,5.988,5.988-3.407,3.408-1.263-1.263c.009.019.017.037.024.055a1.821,1.821,0,0,0-.1-.21.51.51,0,0,0-.033-.075.785.785,0,0,0-.147-.2c-.234-.236-.728-.686-1.137-1.039l-5.855-5.036a1.629,1.629,0,0,0-1.064-.383,1.624,1.624,0,0,0-1.051.371l-6.009,5.052c-.215.183-.427.381-.605.562-.089.092-.169.18-.237.261a1.687,1.687,0,0,0-.181.252.639.639,0,0,0-.065.178h0a1.9,1.9,0,0,0-.106.213l-1.264,1.263-3.408-3.408,5.99-5.988,3.406,3.406-1.84,1.843,2.782-2.341-11.569-11.567a1.462,1.462,0,0,0-2.07,0l-5.36,5.356a1.467,1.467,0,0,0,0,2.071l12.965,12.964.108-1.334-.284-.283.333-.333-.574,7.107.2-2.5-12.75,12.748a1.467,1.467,0,0,0,0,2.071l5.36,5.359a1.466,1.466,0,0,0,2.07,0l4.014-4.015-.492,6.1c0,.039-.005.079-.005.117a1.386,1.386,0,0,0,.4.982,1.39,1.39,0,0,0,.7.375h.015l.119.019h.024c.04,0,.081,0,.122.006h18.566c.041,0,.082,0,.122-.006h.024l.118-.018a.048.048,0,0,1,.017,0,1.39,1.39,0,0,0,.7-.375,1.379,1.379,0,0,0,.4-.982.962.962,0,0,0-.005-.116l-.546-6.8.054.692,4.014,4.015a1.469,1.469,0,0,0,2.072,0l5.358-5.359a1.466,1.466,0,0,0,0-2.071Zm6.041-22.328a.442.442,0,0,1,.315-.13.448.448,0,0,1,.316.13l5.357,5.358a.435.435,0,0,1,.129.315.441.441,0,0,1-.129.316l-3.092,3.092-5.988-5.989Zm-7.22,7.219,3.408-3.407,5.989,5.989-3.408,3.407Zm-28.578-1.23a.444.444,0,0,1-.129-.316.438.438,0,0,1,.129-.315l5.359-5.358a.441.441,0,0,1,.314-.13.441.441,0,0,1,.315.13l3.092,3.092-5.988,5.989Zm3.812,3.812,5.989-5.989,3.406,3.407-5.988,5.988Zm26.626,14.648,3.407,3.406-3.371,3.372-.508-6.306Zm-9.966-14.117a.621.621,0,0,1,.394-.131.619.619,0,0,1,.4.137l5.543,4.77h-12.015Zm-9.125,14.117.472.472-.508,6.306-3.371-3.372Zm-5.359,17.335a.441.441,0,0,1-.315.13.439.439,0,0,1-.314-.13l-5.359-5.357a.445.445,0,0,1-.129-.316.441.441,0,0,1,.129-.316l3.092-3.091,5.988,5.988Zm5.182-8.834-.32,3.973-1.049,1.05-5.989-5.988,3.407-3.408,3.983,3.983Zm12.4,12.128h-5.179V2404.6a.49.49,0,0,1,.132-.331.43.43,0,0,1,.316-.138h4.287a.428.428,0,0,1,.315.138.481.481,0,0,1,.13.331Zm6.871-.1a.368.368,0,0,1-.267.1h-5.583V2404.6a1.508,1.508,0,0,0-1.465-1.545h-4.287a1.508,1.508,0,0,0-1.465,1.545v7.793h-5.752a.547.547,0,0,1-.078-.005l-.006,0a.374.374,0,0,1-.185-.1.372.372,0,0,1-.1-.261V2412l2.267-28.071a.525.525,0,0,1,.173-.338.522.522,0,0,1,.35-.145h13.715a.519.519,0,0,1,.351.145.528.528,0,0,1,.173.338l2.265,28.069a.282.282,0,0,1,0,.035A.364.364,0,0,1-1451.8,2412.292Zm.5-8.051-.321-3.974-.031-.389,3.982-3.983,3.408,3.408-5.989,5.988Zm10.85-.5-5.357,5.357a.44.44,0,0,1-.316.129.434.434,0,0,1-.315-.129l-3.092-3.092,5.988-5.988,3.092,3.091a.438.438,0,0,1,.129.316A.442.442,0,0,1-1440.447,2403.745Z",
    transform: "translate(1498.296 -2366.167)",
    fill: "#6b6a7e"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo06);
export default __webpack_public_path__ + "static/media/logo06.7fcfefcaa956903796a1150cbef55634.svg";
export { ForwardRef as ReactComponent };